module.exports = __webpack_public_path__ + "img/tab-4.a6a511a0.png";